import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { PrintingComponent } from './printing.component';
import { TranslateModule } from '@ngx-translate/core';
import { AuthService } from '../../../../../src/app/shared/auth/auth.service';
import { AuthGuard } from '../../../../../src/app/shared/auth/auth-guard.service';
import { PrintServicesComponent } from './print-layout/printservices.component';
import { PrintheaderviewComponent } from './print-layout/printheaderview.component';
import { PrintfooterviewComponent } from './print-layout/printfooterview.component';
import { IvfPrintviewComponent } from './print-layout/ivfprintview.component';
import { FolliculargrowthPVComponent } from './print-layout/ivf-printview/folliculargrowth.component';
import { EggsourcePVComponent } from './print-layout/ivf-printview/eggsource.component';
import { PickupdetailsPVComponent } from './print-layout/ivf-printview/pickupdetails.component';
import { OocytequalityPVComponent } from './print-layout/ivf-printview/oocytequality.component';
import { SpermsourcedetailsPVComponent } from './print-layout/ivf-printview/spermsourcedetails.component';
import { SemendataanalysisPVComponent } from './print-layout/ivf-printview/semendataanalysis.component';
import { InseminationlogPVComponent } from './print-layout/ivf-printview/Inseminationlog.component';
import { EmbryotransferPVComponent } from './print-layout/ivf-printview/embryotransfer.component';
import { OpbillComponent } from './print-layout/ivf-printview/opbill.component';
import { CaserecordComponent } from './print-layout/ivf-printview/caserecord.component';
import { FollicularscansPVComponent } from './print-layout/ivf-printview/follicularscans.component';
import { CaserecordindividualComponent } from './print-layout/ivf-printview/caserecordindividual.component';
import { AdvancereceiptComponent } from './print-layout/ivf-printview/advreceipt.component';
import { A5AdvancereceiptComponent } from './print-layout/ivf-printview/A5/a5advreceipt.component';
import { PharmacybillComponent } from './print-layout/ivf-printview/pharmacybill.component';
import { IpbillsummaryComponent } from './print-layout/ivf-printview/ipbillsummary.component';
import { AdmissionComponent } from './print-layout/ivf-printview/admission.component';
import { DischargesummaryComponent } from './print-layout/ivf-printview/dischargesummary.component';
import { DischargeslipComponent } from './print-layout/ivf-printview/dischargeslip.component';
import { Labsample1Component } from './print-layout/ivf-printview/labsample1.component';
import { Labsample2Component } from './print-layout/ivf-printview/labsample2.component';
import { Labsample3Component } from './print-layout/ivf-printview/labsample3.component';
import { Printing2Component } from './print-layout/printing2.component';
import { IpitemisedbillComponent } from './print-layout/ivf-printview/ipitemisedbill.component';
import { EmbryogradingPVComponent } from './print-layout/ivf-printview/embryograding.component';
import { CryostoragePVComponent } from './print-layout/ivf-printview/cryostorage.component';
import { FclinicalexaminationPVComponent } from './print-layout/ivf-printview/fclinicalexamination.component';
import { OocytequalitydropletPVComponent } from './print-layout/ivf-printview/oocytequalitydroplet.component';
import { InseminationlogDropletPVComponent } from './print-layout/ivf-printview/Inseminationlogdroplet.component';
import { SpermsourcedetailsDropletPVComponent } from './print-layout/ivf-printview/spermsourcedetailsdroplet.component';
import { EmbryogradingDropletPVComponent } from './print-layout/ivf-printview/embryogradingdroplet.component';
import { FetPVComponent } from './print-layout/ivf-printview/fet.component';
import { PrintlayoutIDLComponent } from './print-layout/printlayoutIDL.component';
import { IDLComponent } from './print-layout/ivf-printview/IDL.component';
import { PrintingIdlComponent } from './printingidl.component';
import { EmbryotransferdropletPVComponent } from './print-layout/ivf-printview/embryotransferdroplet.component';
import { ActivitytrackingPVComponent } from './print-layout/ivf-printview/activitytrackingPV.component';
import { CryostorageDropletPVComponent } from './print-layout/ivf-printview/cryostoragedroplet.component';
import { FollicularscansTCPVComponent } from './print-layout/ivf-printview/follicularscanstc.component';
import { FollicularscansTCIndiPVComponent } from './print-layout/ivf-printview/follicularscanstcindi.component';
import { PregnancytrackerPVComponent } from './print-layout/ivf-printview/pregnancytracker.component';
import { ExpensesreportPVComponent } from './print-layout/ivf-printview/expensesreport.component';
import { ServicesviewPVComponent } from './print-layout/ivf-printview/servicesviewPV.component';
import { IohvieworderPVComponent } from './print-layout/ivf-printview/iohvieworderPV.component';
import { IohvieworderPVindiComponent } from './print-layout/ivf-printview/iohvieworderPVindi.component';
import { ConsumptionReceiptPVComponent } from './print-layout/ivf-printview/consumptionreceiptPV.component';
import { ConsumptionPVComponent } from './print-layout/ivf-printview/consumptionPV.component';
import { PrescriptionPVComponent } from './print-layout/ivf-printview/prescription.component';
import { RefundbillPVComponent } from './print-layout/ivf-printview/refundbill.component';
import { A5OpbillComponent } from './print-layout/ivf-printview/A5/A5opbill.component';
import { A5RxbillComponent } from './print-layout/ivf-printview/A5/A5rxbill.component';
import { A5advrcptComponent } from './print-layout/ivf-printview/A5/A5advrcpt.component';
import { PrintlayoutA4billingComponent } from './print-layout/printlayoutA4billing.component';
import { MaterialtrackingPVComponent } from './print-layout/ivf-printview/materialtrackingPV.component';
import { AdmadvancebillComponent } from './print-layout/ivf-printview/admadvancebill.component';
import { AdmbillsummaryComponent } from './print-layout/ivf-printview/admbillsummary.component';
import { AdmitemwisebillComponent } from './print-layout/ivf-printview/admitemwisebill.component';
import { AdmadvancebillindiComponent } from './print-layout/ivf-printview/admadvancebillindi.component';
import { PrintlayoutRXbillingComponent } from './print-layout/printlayoutRXbilling.component';
import { printlayoutRXA5Component } from './print-layout/printlayoutRXA5.component';
import { ServicesrevenuePVComponent } from './print-layout/ivf-printview/servicesrevenuePV.component';
import { FclinicalexaminationNoHeaderPVComponent } from './print-layout/ivf-printview/fclinicalexaminationnoheader.component';
import { PrintlayoutNoHeaderComponent } from './print-layout/printlayoutNoHeader.component';
import { MyWorkBookPVComponent } from './print-layout/ivf-printview/myworkbookPV.component';
import { DeptConsumptionReceiptPVComponent } from './print-layout/ivf-printview/deptconsumptionreceiptPV.component';
import { PurchaseOrderPVComponent } from './print-layout/ivf-printview/purchaseorderPV.component';
import { PrintlayoutPOComponent } from './print-layout/printlayoutPO.component';
import { A5opbillSvc_ProviderComponent } from './print-layout/ivf-printview/A5/A5opbillSvc_Provider.component';
import { opbillSvc_ProviderComponent } from './print-layout/ivf-printview/opbillSvc_Provider.component';
import { ReturnMaterialPVComponent } from './print-layout/ivf-printview/returnmaterialPV.component';
import { AllReturnedMaterialPVComponent } from './print-layout/ivf-printview/allreturnedmaterialPV.component';
import { PrintlayoutA4labComponent } from './print-layout/printlayoutA4lab.component';
import { PrintlayoutA4generalComponent } from './print-layout/printlayoutA4general.component';



const routes: Routes = [
    {
        path: 'print',
        outlet:'print',
        component: PrintingComponent, canActivate: [AuthGuard],

        children: [            

            { path: 'printservice', component: PrintServicesComponent, canActivate: [AuthGuard] },
            { path: 'folliculargrowth', component: FolliculargrowthPVComponent, canActivate: [AuthGuard] },
            //{ path: 'opbill', component: OpbillComponent, canActivate: [AuthGuard] },            
            { path: 'a5advreceipt', component: A5AdvancereceiptComponent, canActivate: [AuthGuard] },
            //{ path: 'pharmacybill', component: PharmacybillComponent, canActivate: [AuthGuard] },
            { path: 'ipbillsummary', component: IpbillsummaryComponent, canActivate: [AuthGuard] },
            //{ path: 'ipitemisedbill', component: IpitemisedbillComponent, canActivate: [AuthGuard] },
            { path: 'admission', component: AdmissionComponent, canActivate: [AuthGuard] },
            { path: 'dischargesummary', component: DischargesummaryComponent, canActivate: [AuthGuard] },
            { path: 'dischargeslip', component: DischargeslipComponent, canActivate: [AuthGuard] },         
            { path: 'labsample3', component: Labsample3Component, canActivate: [AuthGuard] },
            { path: 'caserecord', component: CaserecordComponent, canActivate: [AuthGuard] },
            { path: 'caserecordindividual', component: CaserecordindividualComponent, canActivate: [AuthGuard] },
           
            //{ path: '', outlet: "printheaderview", component: PrintheaderviewComponent, canActivate: [AuthGuard] },
            //{ path: '', outlet: "printfooterview", component: PrintfooterviewComponent, canActivate: [AuthGuard] },
            //{ path: '', outlet: "ivfprintview", component: IvfPrintviewComponent, canActivate: [AuthGuard] },

            //{ path: '', outlet: "eggsource", component: EggsourcePVComponent, canActivate: [AuthGuard] },
            { path: 'oocytequality', component: OocytequalityPVComponent, canActivate: [AuthGuard] },
            { path: 'spermsourcedetails', component: SpermsourcedetailsPVComponent, canActivate: [AuthGuard] },
             //{ path: '', outlet: "semendataanalysis", component: SemendataanalysisPVComponent, canActivate: [AuthGuard] },
            { path: 'inseminationlog', component: InseminationlogPVComponent, canActivate: [AuthGuard] },
            { path: 'embryograding', component: EmbryogradingPVComponent, canActivate: [AuthGuard] },
            { path: 'embryotransfer', component: EmbryotransferPVComponent, canActivate: [AuthGuard] },
            { path: 'cryostorage', component: CryostoragePVComponent, canActivate: [AuthGuard] },            
            { path: 'activitytrackingPV', component: ActivitytrackingPVComponent, canActivate: [AuthGuard] },
            { path: 'cryostoragedroplet', component: CryostorageDropletPVComponent, canActivate: [AuthGuard] },
            { path: 'expensesreport', component: ExpensesreportPVComponent, canActivate: [AuthGuard] },            
            { path: 'iohvieworderPV', component: IohvieworderPVComponent, canActivate: [AuthGuard] },
            { path: 'iohvieworderPVindi', component: IohvieworderPVindiComponent, canActivate: [AuthGuard] },
            { path: 'consumptionPV', component: ConsumptionPVComponent, canActivate: [AuthGuard] },
            { path: 'refundbill', component: RefundbillPVComponent, canActivate: [AuthGuard] },
            { path: 'materialtrackingPV', component: MaterialtrackingPVComponent, canActivate: [AuthGuard] },
            { path: 'servicesrevenuePV', component: ServicesrevenuePVComponent, canActivate: [AuthGuard] },
            { path: 'myworkbookPV', component: MyWorkBookPVComponent, canActivate: [AuthGuard] },
            { path: 'deptconsumptionreceiptPV', component: DeptConsumptionReceiptPVComponent, canActivate: [AuthGuard] },
            { path: 'returnmaterialPV', component: ReturnMaterialPVComponent, canActivate: [AuthGuard] },
            { path: 'allreturnedmaterialPV', component: AllReturnedMaterialPVComponent, canActivate: [AuthGuard] },
            
            //{ path: 'IDL', component: IDLComponent, canActivate: [AuthGuard] },
            
        ]
    },

  {
    path: 'print2',
    outlet: 'print2',
    component: Printing2Component, canActivate: [AuthGuard],

    children: [

      { path: 'ipitemisedbill', component: IpitemisedbillComponent, canActivate: [AuthGuard] },

    ]

  },

  {
    path: 'print',
    outlet: 'print',
    component: PrintingIdlComponent, canActivate: [AuthGuard],

    children: [

      { path: 'IDL', component: IDLComponent, canActivate: [AuthGuard] },
      { path: 'A5opbill', component: A5OpbillComponent, canActivate: [AuthGuard] },
      { path: 'A5opbillSvc_Provider', component: A5opbillSvc_ProviderComponent, canActivate: [AuthGuard] },
      { path: 'A5advrcpt', component: A5advrcptComponent, canActivate: [AuthGuard] },

    ]

  },

  {
    path: 'print',
    outlet: 'print',
    component: printlayoutRXA5Component, canActivate: [AuthGuard],

    children: [

      { path: 'A5rxbill', component: A5RxbillComponent, canActivate: [AuthGuard] },

    ]

  },

  {
    path: 'print',
    outlet: 'print',
    component: PrintlayoutA4billingComponent, canActivate: [AuthGuard],

    children: [

      { path: 'opbill', component: OpbillComponent, canActivate: [AuthGuard] },
      { path: 'opbillSvc_Provider', component: opbillSvc_ProviderComponent, canActivate: [AuthGuard] },
      { path: 'advreceipt', component: AdvancereceiptComponent, canActivate: [AuthGuard] },
      { path: 'admadvancebill', component: AdmadvancebillComponent, canActivate: [AuthGuard] },
      { path: 'admbillsummary', component: AdmbillsummaryComponent, canActivate: [AuthGuard] },
      { path: 'admitemwisebill', component: AdmitemwisebillComponent, canActivate: [AuthGuard] },
      { path: 'admadvancebillindi', component: AdmadvancebillindiComponent, canActivate: [AuthGuard] },

    ]

  },
  {
    path: 'print',
    outlet: 'print',
    component: PrintlayoutA4labComponent, canActivate: [AuthGuard],

    children: [

      { path: 'labsample1', component: Labsample1Component, canActivate: [AuthGuard] },
      { path: 'labsample2', component: Labsample2Component, canActivate: [AuthGuard] },

    ]

  },
  {
    path: 'print',
    outlet: 'print',
    component: PrintlayoutA4generalComponent, canActivate: [AuthGuard],

    children: [

      { path: 'servicesviewPV', component: ServicesviewPVComponent, canActivate: [AuthGuard] },
      { path: 'fclinicalexamination', component: FclinicalexaminationPVComponent, canActivate: [AuthGuard] },
      { path: 'follicularscans', component: FollicularscansPVComponent, canActivate: [AuthGuard] },
      { path: 'pickupdetails', component: PickupdetailsPVComponent, canActivate: [AuthGuard] },
      { path: 'follicularscanstc', component: FollicularscansTCPVComponent, canActivate: [AuthGuard] },
      { path: 'follicularscanstcindi', component: FollicularscansTCIndiPVComponent, canActivate: [AuthGuard] },
      { path: 'oocytequalitydroplet', component: OocytequalitydropletPVComponent, canActivate: [AuthGuard] },
      { path: 'spermsourcedetailsdroplet', component: SpermsourcedetailsDropletPVComponent, canActivate: [AuthGuard] },
      { path: 'inseminationlogdroplet', component: InseminationlogDropletPVComponent, canActivate: [AuthGuard] },
      { path: 'embryogradingdroplet', component: EmbryogradingDropletPVComponent, canActivate: [AuthGuard] },
      { path: 'fet', component: FetPVComponent, canActivate: [AuthGuard] },
      { path: 'embryotransferdroplet', component: EmbryotransferdropletPVComponent, canActivate: [AuthGuard] },
      { path: 'pregnancytracker', component: PregnancytrackerPVComponent, canActivate: [AuthGuard] },
      { path: 'prescription', component: PrescriptionPVComponent, canActivate: [AuthGuard] },
      { path: 'consumptionreceiptPV', component: ConsumptionReceiptPVComponent, canActivate: [AuthGuard] },

    ]

  },
  {
    path: 'print',
    outlet: 'print',
    component: PrintlayoutRXbillingComponent, canActivate: [AuthGuard],

    children: [

      { path: 'pharmacybill', component: PharmacybillComponent, canActivate: [AuthGuard] },
    ]

  },
  {
    path: 'print',
    outlet: 'print',
    component: PrintlayoutPOComponent, canActivate: [AuthGuard],

    children: [

      { path: 'purchaseorderPV', component: PurchaseOrderPVComponent, canActivate: [AuthGuard] },
    ]

  },
  {
    path: 'print',
    outlet: 'print',
    component: PrintlayoutNoHeaderComponent, canActivate: [AuthGuard],

    children: [

      { path: 'fclinicalexaminationnoheader', component: FclinicalexaminationNoHeaderPVComponent, canActivate: [AuthGuard] },
    ]

  },
];


@NgModule({
  declarations: [],
    imports: [RouterModule.forRoot(routes),
    CommonModule
    //RouterModule.forChild([
    //  {
    //        path: 'print',
          
    //      //  outlet:'print',
    //        component: PrintingComponent, canActivate: [AuthGuard],

    //    children: [
         
    //      { path: 'printservice', component: PrintServicesComponent, canActivate: [AuthGuard] },
    //      { path: 'folliculargrowth', component: FolliculargrowthPVComponent, canActivate: [AuthGuard] },
    //      { path: 'opbill', component: OpbillComponent, canActivate: [AuthGuard] },
    //      { path: 'caserecord', component: CaserecordComponent, canActivate: [AuthGuard] },
    //        { path: 'caserecordindividual', component: CaserecordindividualComponent, canActivate: [AuthGuard] },
    //        { path: 'follicularscans', component: FollicularscansPVComponent, canActivate: [AuthGuard], outlet: 'print'}, //, outlet:'print'
    //      //{ path: '', outlet: "printheaderview", component: PrintheaderviewComponent, canActivate: [AuthGuard] },
    //      //{ path: '', outlet: "printfooterview", component: PrintfooterviewComponent, canActivate: [AuthGuard] },
    //      //{ path: '', outlet: "ivfprintview", component: IvfPrintviewComponent, canActivate: [AuthGuard] },
         
    //      //{ path: '', outlet: "eggsource", component: EggsourcePVComponent, canActivate: [AuthGuard] },
    //      { path: 'pickupdetails', component: PickupdetailsPVComponent, canActivate: [AuthGuard] },
    //      //{ path: '', outlet: "oocytequality", component: OocytequalityPVComponent, canActivate: [AuthGuard] },
    //      //{ path: '', outlet: "spermsourcedetails", component: SpermsourcedetailsPVComponent, canActivate: [AuthGuard] },
    //      //{ path: '', outlet: "semendataanalysis", component: SemendataanalysisPVComponent, canActivate: [AuthGuard] },
    //      //{ path: '', outlet: "inseminationlog", component: InseminationlogPVComponent, canActivate: [AuthGuard] },
    //      //{ path: '', outlet: "embryotransfer", component: EmbryotransferPVComponent, canActivate: [AuthGuard] },


    //    ]

    //  },

    //])
  ],
   providers: [
    TranslateModule,
    //Toastr and auth providers
    // { provide: ToastOptions, useClass: CustomOption },
    AuthService,
    AuthGuard
    

  ],
})
export class PrintRoutingModule { }
